import React, { useRef } from "react";
import Calendar from "react-calendar";
import { PageHeader } from "shared";
import InputControl from "shared/components/InputControl";

export const StudentCalendar = ({
  setActiveStartDate,
  attendanceProgramSelected,
  datesLoading,
  showMarker,
  getClassess,
  programList = [],
  onProgramChange,
  tileDisabled,
}) => {
  const ref = useRef();

  const titleEndComponent = (
    <div className="select-dropdown-group">
      <InputControl
        type="react-select"
        className="form-control react-select-drop"
        name="name"
        options={programList}
        isValid={true}
        placeholder="All Programs"
        value={
          attendanceProgramSelected
            ? programList.find(
                (item) => item.value === attendanceProgramSelected
              )
            : null
        }
        onChange={onProgramChange}
        isDisabled={datesLoading}
      />
    </div>
  );

  const subTitle = (
    <p className="attendance-subtitle">
      View your attendance history and stay on track.
    </p>
  );

  return (
    <div className="attendance px-4 row p-2 pb-4 pt-4 mx-1 mx-md-0">
      <PageHeader
        titleEndComponent={titleEndComponent}
        title="Attendance"
        subTitle={subTitle}
        isBreadCrumbsRequired={false}
      />
      <Calendar
        inputRef={ref}
        calendarType="gregory"
        next2Label={false}
        prev2Label={false}
        onActiveStartDateChange={({ activeStartDate }) =>
          setActiveStartDate(activeStartDate)
        }
        tileDisabled={({ date, view }) => tileDisabled(date, view)}
        tileContent={({ date, view }) => showMarker(date, view)}
        tileClassName={({ date, view }) => getClassess(date, view)}
      />
    </div>
  );
};
